export default "__VITE_ASSET__Cdo9KAFm__"